import React from 'react';
import './main.less';

import { Link } from 'react-router';
import Clipboard from 'react-copy-to-clipboard';

import moment from 'moment';

function renderImageLink({ child, value }, { row }) {
	return (
		<a
			className='banners-image-link'
			href={row.image}
			target='_blank'
		>
			<img src={row.image} />
		</a>
	);
}

function renderLanguage({ value }) {
	return (
		<span className={`banners-flag-icon flag-icon-${value}`} />
	);
}

function renderActions(_, { row }) {
	return (
		<div className='banners-icons'>
			<Clipboard text={row.image}>
				<span className='banners-copy-icon' />
			</Clipboard>
			<Link
				className='banners-edit-icon'
				to={`/popups/images/${row.id}/editor`}
			/>
		</div>
	);
}

export default [
	[
		{
			index: 'id',
			header: {
				title: 'ID'
			},
			column: {}
		},
		{
			index: 'image',
			header: {
				title: 'image'
			},
			column: {
				className: 'banners-image-table-image',
				render: renderImageLink
			}
		},
		{
			index: 'language',
			header: {
				title: 'language'
			},
			column: {
				render: renderLanguage
			}
		},
		{
			index: 'title',
			header: {
				title: 'title'
			},
			column: {
				className: 'banners-image-table-title'
			}
		},
		{
			index: 'created_at',
			header: {
				title: 'created at'
			},
			column: {
				format: v => moment(v).format('DD.MM.YYYY HH:mm')
			}
		},
		{
			index: 'actions',
			header: {
				title: 'actions'
			},
			column: {
				render: renderActions
			}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/popups/image/list/table-initial-data.js